import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { openExternalUrl } from '../safe-url';

@Component({
    selector: 'app-pdf-detail-modal',
    templateUrl: './pdf-detail-modal.component.html',
    styleUrls: ['./pdf-detail-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class PdfDetailModalComponent implements OnInit {
    @Input() originUrl: string;
    @Input() pdfUrl: string;
    @Input() pdfAsBase64;

    pdf: string;

    constructor(public activeModal: NgbActiveModal, private http: HttpClient) {}

    ngOnInit(): void {
        if (this.pdfAsBase64?.pdf) {
            this.pdf = `data:application/pdf;base64,${this.pdfAsBase64.pdf}`;
        }
    }

    openInNewWindow() {
        openExternalUrl(this.pdfUrl);
    }

    export() {
        //does not work yet
        let headers = new HttpHeaders();
        headers = headers.set('Accept', 'application/pdf');
        return this.http.get(this.pdfUrl, {
            headers: headers,
            responseType: 'blob',
        });
    }
}
